import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
let zoneSelectVirtual = class zoneSelectVirtual extends Vue {
    apiRequestNum;
    zoneIdArr = [];
    get zoneVirtualTree() {
        return PortraitCenterModule.zoneVirtualTree;
    }
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    onZoneVirtualTreeChange() {
        this.zoneVirtualTree.forEach((item) => {
            if (item.type === 'ENTIRE_ZONE') {
                this.zoneIdArr = [item.value];
            }
        });
    }
    handleChange() {
        const newArray = [...this.zoneIdArr];
        const val = newArray.pop();
        if (typeof Number(val) === 'number' && !isNaN(Number(val))) {
            PortraitCenterModule.getCurrentZoneId(Number(val));
        }
    }
};
__decorate([
    Prop()
], zoneSelectVirtual.prototype, "apiRequestNum", void 0);
__decorate([
    Watch('zoneVirtualTree')
], zoneSelectVirtual.prototype, "onZoneVirtualTreeChange", null);
zoneSelectVirtual = __decorate([
    Component({
        name: 'zoneSelectVirtual',
        components: {},
        i18n: { messages: lang },
    })
], zoneSelectVirtual);
export default zoneSelectVirtual;
